export default "__VITE_ASSET__BZIkPJjv__"